import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import {MatEditor} from "maticzeditor"

const AddPlanModal = (props) => {
    const {onChange, validateError, onEditorChange, answer, selectFileChange, preview_file, dummy, handlechangeCheckBox, AddRagePrice, AddTire, InputCount, pushAndPopdata, pushAndPopAdd, PlannedLaunchpad, AddPlan} = props

    const [showModel, setShowModel] = useState(true)

    return (
        <div className='modals'>
            <Modal
                onHide={() => { props.onDismiss() }}
                show={showModel}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton onClick={() => props.onDismiss()}>
                    <Modal.Title>Add / Update Plan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="newthememodal">
                        <div container>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex ">
                              <span className="labelspan mb-sm-0 mb-2 me-2">
                                Name of Plan
                              </span>
                              <input
                                type="text"
                                id="PackName"
                                className="edit_inputs_align"
                                placeholder="Plan Name*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {validateError.PackName && (
                              <span className="text-danger mtm-1">
                                {validateError.PackName}
                              </span>
                            )}
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div>
                                {" "}
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Display Name
                                </span>
                              </div>
                              <input
                                type="text"
                                id="displayName"
                                className="edit_inputs_align"
                                placeholder="Display Name*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.displayName && <span className="text-danger mtm-1">{validateError.displayName}</span>
                            }
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div>
                                {" "}
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Short Discription
                                </span>
                              </div>
                              <input
                                type="text"
                                id="ShortDiscription"
                                className="edit_inputs_align"
                                placeholder="Short Discription*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.ShortDiscription && <span className="text-danger mtm-1">{validateError.ShortDiscription}</span>
                            }
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex ">
                              <div>
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Description
                                </span>{" "}
                              </div>
                              {/* <CKEditor
                                // value={answer}
                                // data={}
                                //onDataReady={()=>alert(1)}
                                initData={<p>{ReactHTMLParser()}</p>}
                                id="answer"
                                onChange={(e) => onEditorChange(e)}
                              /> */}
                              <MatEditor sendata={answer} outdata={(evt) => onEditorChange(evt)} />
                                    {/* <ReactSummernote
                                                // children="<p>water</p>"
                                                children={ReactHTMLParser(answer)}
                                                options={{
                                                    //   lang: 'ru-RU',
                                                    height: 400,
                                                    dialogsInBody: true,
                                                    toolbar: [
                                                        ["style", ["style"]],
                                                        ["font", ["bold", "underline", "clear"]],
                                                        ["fontname", ["fontname"]],
                                                        ["para", ["ul", "ol", "paragraph"]],
                                                        ["table", ["table"]],
                                                        ["insert", ["link", "picture", "video"]],
                                                        ["view", ["fullscreen", "codeview"]],
                                                    ],
                                                }}
                                                id="answer"
                                                onChange={(e) => onEditorChange(e)}
                                            /> */}

                              {/* <textarea className='edit_inputs_align' id="Discrption"
                                onChange={(e) => onChange(e)}
                              ></textarea> */}
                              {/* {
                                validateError.Discrption && <span className="text-danger">{validateError.Discrption}</span>
                              } */}
                            </div>
                            {
                              validateError.Discrption && <span className="text-danger mtm-1">{validateError.Discrption}</span>
                            }
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                {" "}
                                <span className="labelspan me-2">Currency</span>
                              </div>
                              <input
                                type="text"
                                id="Currency"
                                className="edit_inputs_align"
                                placeholder="Currency*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />


                              {/* <div class="dropdown curncy_drpdwn">
          <button class=" dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Currency*
          </button>
          <div class="dropdown-menu curncy_drpdwn_menu">
            <a class="dropdown-item" href="#">ETH</a>
            <a class="dropdown-item" href="#">ETH</a>
            <a class="dropdown-item" href="#">ETH</a>
          </div>
        </div> */}

                            </div>
                            {
                              validateError.Currency && <span className="text-danger mtm-1">{validateError.Currency}</span>
                            }

                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                <span className="labelspan me-2">Country</span>
                              </div>
                              <input
                                type="text"
                                id="Country"
                                className="edit_inputs_align"
                                placeholder="Enter Country*"
                                name="Country Name"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.Country && <span className="text-danger mtm-1">{validateError.Country}</span>
                            }
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex ">
                              <div>
                                {" "}
                                <span className="labelspan img_lablespan me-2">
                                  Plan Image
                                </span>
                              </div>
                              {/* <input type="text" id="productName" className='edit_inputs_align me-2' placeholder='Wallet Address*' name="wallet address"
                                onChange={(e) => onChange(e)}
                              /> */}
                              <div className="addplan_mdl_img_inp_dtls">
                                <span>Select File*</span>

                              </div>
                              <button className="admin_mdl_red_btn admn_img_upld_btn">
                                Upload
                                <input
                                  className="addplan_mdl_img_inp addpln_hidden_dtl"
                                  type="file"
                                  name="file"
                                  accept="image/*"
                                  onChange={selectFileChange}
                                />
                              </button>
                            </div>
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div className="me-2">
                                {" "}
                                <img
                                  src={preview_file ? preview_file : dummy}
                                  style={{ width: 117 }}
                                />
                              </div>
                              <p style={{ fontWeight: "500" }}>
                                Image Dimension <br /> (150 X 150)
                              </p>
                            </div>
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div>
                              {" "}
                              <span className="labelspan img_lablespan me-2">
                                Billing Cycle
                              </span>
                            </div>
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className=" ">
                              {/* <div>  <span className='labelspan me-2 mb-2'>Billing Cycle</span></div> */}
                              {console.log("AddRagePrice", AddRagePrice, AddTire)}
                              {[...Array(InputCount)].map((val, index) => {
                                return (
                                  <div className="d-sm-flex align-items-center mb-2">
                                    <p className="shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2">
                                      Units
                                    </p>
                                    <input
                                      type="text"
                                      id={"units" + index}
                                      className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                      placeholder="Enter units*"
                                      name="wallet address"
                                      onChange={(e) => pushAndPopdata(e, index)}
                                    />
                                    {/* {
                                      validateError.SingleMintLint && <span className="text-danger">{validateError.SingleMintLint}</span>
                                    } */}

                                    <p className="shrink-0 mb-0 f-12 fw-600 me-2">
                                      Price per Unit
                                    </p>
                                    <input
                                      type="text"
                                      id={"Price" + index}
                                      className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                      placeholder="Enter Price*"
                                      name="wallet address"
                                      onChange={(e) => pushAndPopdata(e, index)}
                                    />
                                    <button
                                      className="admin_mdl_red_btn"
                                      onClick={() => {
                                        pushAndPopAdd(index);
                                      }}
                                    >
                                      Add Tier
                                    </button>
                                  </div>
                                );
                              })}

                              {/* <div className='d-sm-flex align-items-center mb-2'>
                                <p className='shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2'>Units 1 to </p>
                                <input type="text" id="units1" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='Enter units*' name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />
                                {
                                  validateError.SingleMintLint && <span className="text-danger">{validateError.SingleMintLint}</span>
                                }

                                <p className='shrink-0 mb-0 f-12 fw-600 me-2'>Price per Unit</p>
                                <input type="text" id="units1price" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='Enter Price*' name="wallet address" onChange={(e) => onChange(e)} />
                                <button className='btn bluebtn'>Add Tire</button>
                              </div>

                              <div className='d-sm-flex align-items-center mb-2'>
                                <p className='shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2'> Units {units1} to </p>
                                <input type="text" id="units2" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='Enter units*' name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />
                                {
                                  validateError.MultipleMintLint && <span className="text-danger">{validateError.MultipleMintLint}</span>
                                }
                                <p className='shrink-0 mb-0 f-12 fw-600 me-2'>Price per Unit</p>
                                <input type="text" id="units2price" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='Enter Price*' name="wallet address" onChange={(e) => onChange(e)} />
                                <button className='btn bluebtn'>Add Tire</button>
                              </div>

                              <div className='d-sm-flex align-items-center mb-2'>
                                <p className='shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2'> Units {units2} to </p>
                                <input type="text" id="units3" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='Enter units*' name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />
                                {
                                  validateError.Soulbound && <span className="text-danger">{validateError.Soulbound}</span>
                                }
                                <p className='shrink-0 mb-0 f-12 fw-600 me-2'>Price per Unit</p>
                                <input type="text" id="units3price" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='Enter Price*' name="wallet address" onChange={(e) => onChange(e)} />
                                <button className='btn bluebtn'>Add Tire</button>
                              </div>

                              <div className='d-sm-flex align-items-center mb-2'>
                                <p className='shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2'> Units {units3} to </p>
                                <input type="text" id="units4" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='Enter units*' name="wallet address"
                                  onChange={(e) => onChange(e)}
                                />
                                {
                                  validateError.Bulkminting && <span className="text-danger">{validateError.Bulkminting}</span>
                                }
                                <p className='shrink-0 mb-0 f-12 fw-600 me-2'>Price per Unit</p>
                                <input type="text" id="units4price" className='edit_inputs_align me-2 mb-2 mb-sm-0' placeholder='units Price*' name="wallet address" onChange={(e) => onChange(e)} />
                                <button className='btn bluebtn'>Add Tire</button>
                              </div> */}
                            </div>
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex ">
                              <div>
                                {" "}
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  SetUp fee
                                </span>
                              </div>
                              <input
                                type="text"
                                id="Price"
                                className="edit_inputs_align me-2"
                                placeholder="SetUp fee*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {validateError.Price && (
                              <span className="text-danger mtm-1">
                                {validateError.Price}
                              </span>
                            )}
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex align-items-center">
                              <div>
                                {" "}
                                <span className="labelspan me-2">Launch Pad</span>
                              </div>
                              <input
                                type="text"
                                id="walletAddress"
                                className="edit_inputs_align me-2"
                                placeholder="Launch Pad*"
                                name="wallet address"
                              />
                              <p className="shrink-0 mb-0 fw-600 f-12 ">Per unit</p>
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                <span className="labelspan me-2">
                                  Display Launchpad
                                </span>
                              </div>
                              <div className="w-full">
                                <Select

                                  className=" themeselect update_plan_top_slct"
                                  labelId="demo-simple-select-helper-label"
                                  id="demo-simple-select-helper"
                                  options={PlannedLaunchpad}
                                />
                                {/* <MenuItem value={"Professional"}>Professional, TH</MenuItem>
                                  <MenuItem value={"Agency"}>Agency, TH</MenuItem>
                                  <MenuItem value={"LaunchPad"}>LaunchPad, ALL</MenuItem>
                                  <MenuItem value={"Starter"}>Starter, MY</MenuItem>
                                  <MenuItem value={"Professional"}>Professional, MY</MenuItem>
                                  <MenuItem value={"Agency"}>Agency MY</MenuItem>
                                  <MenuItem value={"Starter"}>Starter, PH</MenuItem>
                                  <MenuItem value={"Professional"}>Professional, PH</MenuItem> */}
                              </div>
                            </div>
                          </div>
                          <div className="table_div_head mt-4">
                            <div class="container-fluid edit_table_container_align">
                              <div
                                class="table-responsive"
                                style={{ position: "relative", zIndex: 0 }}
                              >
                                <table class="table edit_user_table_align">
                                  <thead className="tiffany_thead">
                                    <tr>
                                      <th scope="col">LazyMint ERC721 & ERC 1155</th>
                                      <th scope="col">
                                        Bulk LazyMint SoulBound Tokens
                                      </th>
                                      <th scope="col">Bulk Minting</th>
                                      <th scope="col">Token Scanner</th>
                                      <th scope="col">DashBoard And Profile</th>
                                      <th scope="col">Campaign Page</th>
                                    </tr>
                                  </thead>
                                  {/* {PackDetails && PackDetails.length > 0 && PackDetails.map((item, index) => {
                                    console.log("poopadad", item);
                                    return ( */}
                                  <tbody>
                                    <tr>
                                      {/* <th scope="row"></th> */}
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="table_check_align"
                                          id="ERC"
                                          name="ERC"
                                          value="ERC"
                                          onChange={(e) => handlechangeCheckBox(e)}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="table_check_align"
                                          id="Soulbound"
                                          name="SoulBound"
                                          value="Soulbound"
                                          onChange={(e) => handlechangeCheckBox(e)}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="table_check_align"
                                          id="Bulkminting"
                                          name="Bulkminting"
                                          onChange={(e) => handlechangeCheckBox(e)}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="table_check_align"
                                          id="TokenScanner"
                                          name="TokenScanner"
                                          onChange={(e) => handlechangeCheckBox(e)}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="table_check_align"
                                          id="DashBoardAndProfile"
                                          name="DashBoardAndProfile"
                                          onChange={(e) => handlechangeCheckBox(e)}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="table_check_align"
                                          id="DomainCampaign"
                                          name="DomainCampaign"
                                          onChange={(e) => handlechangeCheckBox(e)}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                  {/* )
                                  })} */}
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          {" "}
                          <button
                            className="admin_mdl_red_btn mt-4"
                            onClick={() => {
                              AddPlan();
                            }}
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                </Modal.Body>

            </Modal>

        </div>
    )
}

export default AddPlanModal